import { defineStore } from 'pinia'
import httpClient from '@/api/httpClient'
import { useMessagesStore } from '@/stores/messages'

export const usePublicationStore = defineStore('publication', {
  state: () => ({
    publication: {
      id: null,
      name: null,
      slug: null,
      guid: null,
      url: null,
      notes: null,
      account: null,
      key: null,
      hide_bylines: false,
      hide_content_types: false,
      hide_story_templates: false
    },
  }),

  actions: {
    async fetch({ publicationId }) {
      this.fetchInitiated = true

      try {
        const { data: { publication }} = await httpClient.get(`/api/internal/publications/${publicationId}`)
        this.publication = publication
      } catch (err) {
        useMessagesStore().addError(err)
      }
    },

    async save() {
      return await this.publication.id ? this.update() : this.create()
    },

    async create() {
      const { publication } = this

      return httpClient.post('/api/internal/publications', {
          publication
        })
        .then((resp) => {
          const { data: { status, publication } } = resp
          if (status == 'success') {
            this.publication = publication
            useMessagesStore().addNotice(`${publication.name} publication created`)
          }
          return resp
        })
        .catch(err => {
          console.error(err)
          useMessagesStore().addError(err)
          throw err
        })
    },

    async update() {
      const { publication } = this

      return httpClient.patch(`/api/internal/publications/${publication.id}`, {
          publication
        })
        .then((resp) => {
          const { data: { publication } } = resp
          this.publication = publication
          useMessagesStore().addNotice(`${publication.name} publication saved`)
          return resp
        })
        .catch(err => {
          console.error(err)
          useMessagesStore().addError(err)
          throw err
        })
    }
  },
})
